import React from "react";
import {Page} from "./menu";
import {Box, Button, Card} from "@mui/material";
import {useDispatch} from "react-redux";
import {Route, Routes, useNavigate, useParams} from "react-router-dom";
import {Role} from "../../session_state";
import {hasRole} from "../../hooks/useRole";
import Title from "./Title";


type MenuItemCardProps = {
    page: Page

}
const MenuItemCard = ({page}: MenuItemCardProps) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    return <Card sx={{height: {xs: "100px", sm: "200px"}}}>
        <Button sx={{width: "100%", height: "100%"}} onClick={() => {
            if ("pages" in page) {
                navigate(page.id)
            }
            if ("action" in page && page.action) {
                dispatch(page.action())
            }
            if ("route" in page && page.route) {
                navigate(page.route);
            }
        }}>
            {page.name}
        </Button>
    </Card>
}

type MenuListProps = {
    pages: Page[],
    myRoles: Role[],
    title?: string
}

const MenuList = ({title, pages, myRoles}: MenuListProps) => {

    return <Box key={"a"}
                sx={{
                    "display": "grid",
                    mt: "1em",
                    gridGap: "1em",
                    gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))"
                }}>
        {title && <Title title={title}/>}
        {pages.filter(page => hasRole(myRoles, page.roles))
            .map(page => <MenuItemCard key={page.name} page={page}/>)}
    </Box>
}

const MenuRoute = ({myRoles, pages}: MenuListProps) => {

    const {id} = useParams<"id">()
    let subpage: Page | undefined = undefined
    if (id && pages) {
        subpage = pages.find((p: Page) => p.id === id);
    }

    // filter by roles & render Cards
    return <>
        <Routes>
            <Route
                path={"/*"}
                element={<Button href={"."}>{subpage?.name}</Button>}
            />
        </Routes>
        <Routes>
            <Route
                index
                path={"/"}
                element={<MenuList title={subpage?.name} myRoles={myRoles} pages={subpage?.pages || []}/>}
            />
            <Route
                path={":id/*"}
                element={<MenuRoute myRoles={myRoles} pages={subpage?.pages || []}/>}
            />
        </Routes>

    </>;
}


export default MenuRoute;


